import { render } from "./Coupons.vue?vue&type=template&id=77e04f60&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"

import "./Coupons.vue?vue&type=style&index=0&id=77e04f60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e04f60"]])

export default __exports__